<!-- TODO:  This PoS *really* needs refactoring! -->
<template>
  <div class="tag-browser">
    <breadcrumbs :trail="crumbTrail" :root-label="breadcrumbRootLabel" @crumb-click="navigateTo" />
    <list-selector v-if="showListSelector" @as-list="asListSelected" />
    <list-indexer v-if="showListIndexer" @resolve="indexResolved" @as-list="asListSelected" />
    <drop-down-indexer v-if="showDropDownIndexer" :field="leaf" @resolve="indexResolved" />
    <property-value-query v-if="showPropertyValueQuery" :field="leaf" @resolve="formatResolved" />
    <role-aspect-indexer v-if="showRoleAspectIndexer" @resolve="roleAspectResolved" />
    <role-indexer v-if="showRoleIndexer" :data-context="dataContext" @resolve="roleResolved" />
    <date-time-formatter v-if="showDateTimeFormatter" :field="leaf" @resolve="formatResolved" />
    <currency-formatter v-if="showCurrencyFormatter" :field="leaf" @resolve="formatResolved" />
    <percentage-formatter v-if="showPercentageFormatter" :field="leaf" @resolve="formatResolved" />
    <descendants v-if="showDescendantsResolver" :field="leaf" @resolve="descendantResolved" />
    <related-sharedos v-if="showRelatedSharedosResolver" :field="leaf" @resolve="relatedResolved" />
    <budget-query v-if="showBudgetQuery" :field="leaf" @resolve="budgetQueryResolved" />
    <types v-if="showTypeSpecifier" :field="leaf" @resolve="relatedResolved" />
    <div class="fields" v-if="showFields">
      <div class="filter-bar flex items-center mb-1">
        <filter-control class="flex-to-fill" label="Filter fields" v-model="filter" @update:modelValue="onFilterChanged" />
        <div class="btn btn-secondary filter-bar-action" v-on:click="toggleAllGroupsExpanded" v-if="anyFieldGroupsHaveName">
          <span class="fa" :class="{ 'fa-angles-up': !isExpandAll, 'fa-angles-down': isExpandAll }"></span>
        </div>
      </div>
      <div v-if="fieldGroups.length > 0" class="field-container">
        <field-group v-for="(fieldGroup, idx) in fieldGroups" :index="idx" :key="fieldGroup.key" :group="fieldGroup" :isExpanded="fieldGroup.isExpanded">
          <field v-for="field in fieldGroup.fields" :key="field.value.name" :field="field" :graph="graph"
            :path-string="getPathString(field)" @navigate="navigateForward" @select="fieldSelected"
            @copy="copyToClipboard" />
        </field-group>
      </div>
      <div v-else-if="fields.length > 0" class="field-container">
        <field v-for="field in fields" :key="field.value.name" :field="field" :graph="graph" :path-string="getPathString(field)"
          @navigate="navigateForward" @select="fieldSelected" @copy="copyToClipboard" />
      </div>
      <div v-else>
        <i>No fields found.</i>
      </div>
    </div>
    <textarea ref="clipboard" readonly style="position: absolute; left: -9999px; width: 0; height: 0"></textarea>
  </div>
</template>
<script>
import { mapState } from "vuex";
import graph from "@/services/sharedo/graphService";
import Graph from "@/models/graph";
import Breadcrumbs from "@/components/common/breadcrumbs/Breadcrumbs.vue";
import FilterControl from "@/components/common/filtering/FilterControl.vue";
import ListSelector from "./resolvers/ListSelector.vue";
import ListIndexer from "./resolvers/ListIndexer.vue";
import DropDownIndexer from "./resolvers/DropDownIndexer.vue";
import Descendants from "./resolvers/Descendants.vue";
import RelatedSharedos from "./resolvers/RelatedSharedos.vue";
import DateTimeFormatter from "./resolvers/DateTimeFormatter.vue";
import CurrencyFormatter from "./resolvers/CurrencyFormatter.vue";
import PropertyValueQuery from "./resolvers/PropertyValueQuery.vue";
import PercentageFormatter from "./resolvers/PercentageFormatter.vue";
import BudgetQuery from "./resolvers/BudgetQuery.vue";
import RoleAspectIndexer from "./resolvers/RoleAspectIndexer.vue";
import RoleIndexer from "./resolvers/RoleIndexer.vue"
import Types from "./resolvers/Types.vue";
import Field from "./Field.vue";
import FieldGroup from "./FieldGroup.vue";
import {
  REPEATING_CONTENT_BLOCK,
  REPEATING_TABLE_BLOCK,
} from "@/constants/contentControlTypes";
import {
  COLLECTION_INDEXER,
  DROPDOWN_INDEXER,
  ROLE_ASPECT_INDEXER,
  ROLE_INDEXER
} from "@/constants/sharedoWidgets";
import GroupBuilder from "@/models/builders/groupBuilder";

const getPathString = function (field) {
  const name = field.value.name !== "__result" ? field.value.name : "";
  if (name) {
    return `${this.pathString}${!!this.pathString ? "." : ""}${name}`;
  }

  return this.pathString;
};

const navigateForward = function (field) {
  this.filter = "";
  this.currentPath = [...this.currentPath, field];

  this.logDebug("Navigating to path.", { path: this.currentPath });
};

const navigateTo = function (index) {
  this.filter = "";

  if (index > -1) {
    this.currentPath = this.currentPath.slice(0, index + 1);
  } else {
    this.currentPath = [];
  }

  this.logDebug("Navigating to path.", { path: this.currentPath });
};

const copyToClipboard = function (path) {
  const clipboard = this.$refs.clipboard;
  clipboard.value = path;
  clipboard.select();
  document.execCommand("copy");

  this.logDebug("Path copied to clipboard.", { path });
};

const fieldSelected = function (field) {
  this.filter = "";

  const args = {
    field,
    path: this.getPathString(field),
  };

  this.graph.resetRootName();

  this.logDebug("Field selected.", args);
  this.$emit("field-selected", args);
};

const asListSelected = function () {
  this.filter = "";

  const args = {
    field: this.leaf,
    path: this.pathString,
  };

  this.logDebug("List selected.", args);
  this.$emit("field-selected", args);
};

const updateFromQueryResponse = function (response) {
  this.filter = "";

  this.graph.applySchema(response.result);

  const newRoot = this.graph.getType(response.result.rootName);
  const resultField = newRoot
    .getField("__result")
    .applyQueryString(response.queryString);

  this.currentPath.push(resultField);

  this.logDebug("Updated path from query response.", {
    queryResponse: response,
    resultField,
    path: this.currentPath,
  });
};

const indexResolved = async function (index, valueField = "value") {
  try {
    const root = this.graph.getRoot();
    const request = {
      arguments: {
        [valueField]: index,
      },
      typeName: root.value.baseTypeName,
      typeEntityType: root.value.entityType,
      fieldName: this.leaf.value.name,
      path: this.pathString,
      rootEntityType: this.selectedTemplate,
    };

    const response = await graph.querySchema("doc-gen", request);
    this.logInfo("Queried graph schema.", response);

    this.updateFromQueryResponse(response);
  } catch (error) {
    this.logError("Error resolving index.", { index, error });
    throw error;
  }
};

const roleResolved = async function (roleSystemName) {
  const root = this.graph.getRoot();

  const request = {
    arguments: {
      index: roleSystemName
    },
    fieldName: this.leaf.value.name,
    path: this.pathString,
    rootEntityType: this.selectedTemplate,
    typeEntityType: root.value.entityType,
    typeName: root.value.baseTypeName,
  };

  const response = await graph.querySchema("doc-gen", request);
  this.updateFromQueryResponse(response);
};

const roleAspectResolved = async function (roleAspectSystemName) {
  const root = this.graph.getRoot();

  const request = {
    arguments: {
      aspect: roleAspectSystemName,
    },
    fieldName: this.leaf.value.name,
    path: this.pathString,
    rootEntityType: this.selectedTemplate,
    typeEntityType: root.value.entityType,
    typeName: root.value.baseTypeName,
  };

  const response = await graph.querySchema("doc-gen", request);
  this.updateFromQueryResponse(response);
};

const budgetQueryResolved = async function ({ args, fieldQueryName }) {
  try {
    const root = this.graph.getRoot();
    const request = {
      arguments: {
        positionType: args.positionType,
      },
      fieldQueryName: fieldQueryName,
      typeName: root.value.baseTypeName,
      typeEntityType: root.value.name,
      fieldName: this.leaf.value.name,
      path: this.pathString,
      rootEntityType: this.selectedTemplate,
    };

    if (args.code) {
      request.arguments.code = args.code;
    }

    if (args.total === "total" || args.total === "totalByRollUp") {
      request.arguments.total = true;
    }

    const response = await graph.querySchema("doc-gen", request);
    this.logInfo("Queried graph schema.", response);

    this.updateFromQueryResponse(response);
  } catch (error) {
    this.logError("Error resolving budget query.", {
      error,
      positionType,
      code,
      total,
    });
    throw error;
  }
};

const formatResolved = async function ({ args, fieldQueryName }) {
  try {
    const root = this.graph.getRoot();
    const request = {
      arguments: {
        ...args,
      },
      fieldQueryName: fieldQueryName,
      typeName: root.value.baseTypeName,
      typeEntityType: root.value.entityType,
      fieldName: this.leaf.value.name,
      path: this.pathString,
      rootEntityType: this.selectedTemplate,
    };

    const response = await graph.querySchema("doc-gen", request);
    this.logInfo("Queried graph schema.", response);

    this.updateFromQueryResponse(response);
  } catch (error) {
    this.logError("Error resolving format.", { args, fieldQueryName, error });
    throw error;
  }
};

const descendantResolved = async function (args) {
  try {
    const root = this.graph.getRoot();
    const request = {
      arguments: {
        ...args.arguments,
      },
      fieldQueryName: args.fieldQueryName,
      typeName: root.value.baseTypeName,
      typeEntityType: root.value.name,
      fieldName: this.leaf.value.name,
      path: this.pathString,
      rootEntityType: this.selectedTemplate,
    };

    const response = await graph.querySchema("doc-gen", request);
    this.logInfo("Queried graph schema.", response);

    this.updateFromQueryResponse(response);
  } catch (error) {
    this.logError("Error resolving descendants.", { args, error });
    throw error;
  }
};

const relatedResolved = async function (args) {
  try {
    const root = this.graph.getRoot();
    const request = {
      arguments: {
        ...args.arguments,
      },
      fieldQueryName: args.fieldQueryName,
      typeName: root.value.name,
      typeEntityType: root.value.baseTypeName,
      fieldName: this.leaf.value.name,
      path: this.pathString,
      rootEntityType: this.selectedTemplate,
    };

    const response = await graph.querySchema("doc-gen", request);
    this.logInfo("Queried graph schema.", response);

    this.updateFromQueryResponse(response);
  } catch (error) {
    this.logError("Error resolving related sharedos.", { args, error });
    throw error;
  }
};

const toggleAllGroupsExpanded = function() {
  this.isExpandAll = !this.isExpandAll;
}

const onFilterChanged = function() {
  this.isExpandAll = false;
}

export default {
  components: {
    Breadcrumbs,
    FilterControl,
    Field,
    FieldGroup,
    ListSelector,
    ListIndexer,
    DropDownIndexer,
    Descendants,
    RelatedSharedos,
    DateTimeFormatter,
    CurrencyFormatter,
    PercentageFormatter,
    PropertyValueQuery,
    BudgetQuery,
    RoleAspectIndexer,
    RoleIndexer,
    Types,
  },
  props: {
    dataContext: {
      type: String,
      required: true
    },
    schema: {
      required: true,
    },
    selectedTemplate: {
      required: true,
    },
  },
  data: function () {
    return {
      graph: null,
      currentPath: [],
      filter: "",
      isExpandAll: false
    };
  },
  computed: {
    ...mapState({
      currentPlaceholder: (state) => state.currentPlaceholder,
    }),
    pathString: function () {
      return this.currentPath.reduce((pathStr, field) => {
        if (field.isResult()) {
          pathStr = `${pathStr}${field.value.queryString}`;
        } else {
          pathStr = `${pathStr}${!!pathStr ? "." : ""}${field.value.name}`;
        }

        return pathStr;
      }, "");
    },
    currentType: function () {
      if (this.leaf) {
        return this.leaf.getType();
      }

      if (this.graph) {
        return this.graph.getRoot();
      }
      return null;
    },
    leaf: function () {
      if (this.currentPath.length > 0) {
        return this.currentPath[this.currentPath.length - 1];
      }

      return null;
    },
    currentUnderlyingType: function () {
      if (this.leaf) {
        return this.leaf.getUnderlyingType();
      }

      return this.graph.getRoot();
    },
    fields: function () {
      let fields = this.currentUnderlyingType.getFields(this.currentPath);
      if (fields.length === 0 && this.leaf && this.leaf.value.name === "__result") {
        return [this.leaf];
      }

      if (this.filter) {
        fields = fields.filter(
          (f) =>
            f.value.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
        );
      }

      return fields;
    },
    inRepeaterPlaceholder: function () {
      return (
        this.currentPlaceholder &&
        this.currentPlaceholder.path === this.pathString &&
        (this.currentPlaceholder.type === REPEATING_CONTENT_BLOCK ||
          this.currentPlaceholder.type === REPEATING_TABLE_BLOCK)
      );
    },
    isList: function () {
      return this.currentType && this.currentType.value.kind === "list";
    },
    showListSelector: function () {
      if (this.inRepeaterPlaceholder) {
        return false;
      } else if (this.isList) {
        return !this.leaf.hasIndexer() && !this.showBudgetQuery;
      }

      return false;
    },
    showListIndexer: function () {
      if (this.inRepeaterPlaceholder) {
        return false;
      } else if (this.isList) {
        return this.leaf.getIndexer() === COLLECTION_INDEXER;
      }

      return false;
    },
    showDropDownIndexer: function () {
      if (this.inRepeaterPlaceholder) {
        return false;
      } else if (this.isList) {
        return this.leaf.getIndexer() === DROPDOWN_INDEXER;
      }

      return false;
    },
    showRoleAspectIndexer: function () {
      if (this.leaf) {
        return this.leaf.getIndexer() === ROLE_ASPECT_INDEXER;
      }
    },
    showRoleIndexer: function () {
      if (this.leaf) {
        return this.leaf.getIndexer() === ROLE_INDEXER
      }
    },
    showDescendantsResolver: function () {
      if (this.inRepeaterPlaceholder) {
        return false;
      } else if (this.isList) {
        return this.leaf.hasDescendants();
      }

      return false;
    },
    showRelatedSharedosResolver: function () {
      if (this.inRepeaterPlaceholder) {
        return false;
      } else if (this.isList) {
        return this.leaf.hasRelated();
      }

      return false;
    },
    showTypeSpecifier: function () {
      if (this.inRepeaterPlaceholder) {
        return false;
      } else if (this.leaf) {
        return this.leaf.hasSelectableTypes();
      }

      return false;
    },
    showDateTimeFormatter: function () {
      if (this.leaf) {
        return this.leaf.hasDateTimeFormatter();
      }

      return false;
    },
    showCurrencyFormatter: function () {
      if (this.leaf) {
        return this.leaf.hasCurrencyFormatter();
      }

      return false;
    },
    showPercentageFormatter: function () {
      if (this.leaf) {
        return this.leaf.hasPercentageFormatter();
      }

      return false;
    },
    showPropertyValueQuery: function () {
      if (this.inRepeaterPlaceholder) {
        return false;
      } else if (this.leaf) {
        return this.leaf.hasPropertyValueQuery();
      }

      return false;
    },
    showBudgetQuery: function () {
      if (this.leaf) {
        return this.leaf.hasBudgetAmountQuery();
      }

      return false;
    },
    showFields: function () {
      return (
        this.inRepeaterPlaceholder ||
        (!this.showListSelector &&
          !this.showListIndexer &&
          !this.showDropDownIndexer &&
          !this.showRoleAspectIndexer &&
          !this.showDescendantsResolver &&
          !this.showRelatedSharedosResolver &&
          !this.showDateTimeFormatter &&
          !this.showCurrencyFormatter &&
          !this.showPropertyValueQuery &&
          !this.showPercentageFormatter &&
          !this.showBudgetQuery &&
          !this.showRoleIndexer)
      );
    },
    crumbTrail: function () {
      if (this.currentPath && this.currentPath.length > 0) {
        return this.currentPath.map((field) => field.value.displayName);
      }

      return [];
    },
    breadcrumbRootLabel: function () {
      if (
        this.graph.rootName !== "DocGenQuery" &&
        this.currentPath.length === 0
      ) {
        return this.graph.rootName;
      }

      return "";
    },
    fieldGroups: function () {
      const isExpandAll = this.isExpandAll;
      const builder = new GroupBuilder(
          this.graph,
          this.currentType,
          this.pathString,
          this.filter,
          null,
          !!this.capabilities.calculatedFieldCategories
        );
        const groups = builder.build();

        groups.forEach(g => g.isExpanded = !isExpandAll);
        return groups;
    },
    anyFieldGroupsHaveName: function() {
      return !!this.fieldGroups.find(g => g.name);
    }
  },
  watch: {
    schema: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        const graph = new Graph();
        graph.applySchema(newValue);
        this.graph = graph;
        this.currentPath = [];
      }
    },
  },
  emits: ["field-selected"],
  methods: {
    getPathString,
    navigateForward,
    navigateTo,
    fieldSelected,
    asListSelected,
    updateFromQueryResponse,
    indexResolved,
    descendantResolved,
    relatedResolved,
    copyToClipboard,
    formatResolved,
    budgetQueryResolved,
    roleAspectResolved,
    roleResolved,
    toggleAllGroupsExpanded,
    onFilterChanged
  },
  created: function () {
    const graph = new Graph();
    graph.applySchema(this.schema);
    this.graph = graph;
  },
};
</script>
<style lang="scss" scoped>
@import "../../_css/variables";

.tag-browser {
  margin-top: 1rem;

  & .field-container {
    border: 1px solid $gray-500;
    border-radius: $input-border-radius;
    overflow: hidden;
  }

  & .filter-bar {

    &-action {
      padding: 0.4em 0.7em;
      margin-left: 0.5em;
    }
  }
}
</style>
